/**
 * Central map-provider config (MapTiler infra prep, step 1).
 *
 * The provider FLAG controls which engine future map components use:
 *   REACT_APP_MAP_PROVIDER = "leaflet" (default, current prod) | "maplibre"
 * The MapTiler key comes ONLY from env — never hardcode.
 *
 * MapLibre GL is vendor-neutral: the style URL below is the only
 * MapTiler-specific piece. Swapping provider (Stadia, Protomaps,
 * self-hosted tiles) later means changing ONLY these URLs.
 */
export const MAP_PROVIDER =
  process.env.REACT_APP_MAP_PROVIDER === "maplibre" ? "maplibre" : "leaflet";

export const MAPTILER_KEY = process.env.REACT_APP_MAPTILER_KEY || "";

// MapTiler style ids — production base per founder decision (2026-07):
// "basic-v2-dark" (calm dark, markers stand out). The DealAlert custom
// style will be derived from it later in the MapTiler editor.
export function maptilerStyleUrl(styleId = "basic-v2-dark") {
  if (!MAPTILER_KEY) return null;
  return `https://api.maptiler.com/maps/${styleId}/style.json?key=${MAPTILER_KEY}`;
}

// True only when BOTH the flag is switched AND a key exists —
// callers must fall back to Leaflet otherwise (no regression path).
export function isMapLibreEnabled() {
  return MAP_PROVIDER === "maplibre" && Boolean(MAPTILER_KEY);
}
